<template>
  <b-card>
    <b-tabs v-if="userData" pills>
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Company Information</span>
        </template>
        <info-edit-tab-information
          :user-data="userData"
          @refetch-data="refetchData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import infoStoreModule from "./infoStoreModule";
import InfoEditTabInformation from "./InfoEditTabInformation.vue";

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    InfoEditTabInformation,
  },
  setup() {
    const userData = ref(null);

    const INFO_STORE_MODULE_NAME = "app-info";

    if (!store.hasModule(INFO_STORE_MODULE_NAME))
      store.registerModule(INFO_STORE_MODULE_NAME, infoStoreModule);

    onUnmounted(() => {
      if (store.hasModule(INFO_STORE_MODULE_NAME))
        store.unregisterModule(INFO_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      store
        .dispatch(INFO_STORE_MODULE_NAME + "/fetchUser")
        .then((response) => {
          userData.value = response.data.user;
        })
        .catch((error) => {
          console.log("Fail to refetchData", error);
        });
    };

    onMounted(() => {
      refetchData();
    });

    return {
      userData,
      refetchData,
    };
  },
};
</script>
